/// <amd-module name="Dashboards/RateLimiter/ThrottlingMessageBar" />
import { ThrottlingDocumentationLinkText, ThrottlingLimitExceeded } from "Dashboards/RateLimiter/Resources";
import * as React from "react";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Link } from "VSSUI/Link";
import { IMessageBarProps, MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";

export interface IThrottlingMessageBarProps {
    /**
     * Optional handler for any dismissal of the button
     */
    onDismiss?: () => void;
}

/** Responsible for presentation of Dashboard Throttling Experience under New and Old Dashboard Pages. */
export const ThrottlingMessageBar: React.SFC<IThrottlingMessageBarProps> = props => {
    const throttlingDocLink = "https://go.microsoft.com/fwlink/?LinkId=823950";
    return (
        <MessageBar className={"throttling-message-bar"} onDismiss={props.onDismiss} severity={MessageBarSeverity.Warning}>
            <FormatComponent format={ThrottlingLimitExceeded}>
                <Link href={throttlingDocLink}>{ThrottlingDocumentationLinkText}</Link>
            </FormatComponent>
        </MessageBar>
    );
};
